module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA5klEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GICosI/o3LPCUNezH0UDUB0UycnB2UBpJuOZTnH1NuFu2h4dKBogjkY4acWK3v69QGkNx6knwpRPpynt8dLms0S2Yfp0v8IdcA3VXfshntb2W7SnJXNfe8nu1goB+/kIDVj9x2I60y1oSu7MuemzllRNnaHjNo2AhgD/zmsrQvsXLgtqmLRk6aRL80IJaGA3nSHlNMs3sbu+t8cperKk42w0DYQRWRoGJQAAvIrDfnku/fsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KY.png
// module id = 1187
// module chunks = 0